<template>
	<div :class="$route.name=='bkcode'?'top grey':'top'">

		<div class="header  flex_between">
			<div class="flex_start" style="height: 100%;width: calc(100% - 269px);">
				<img class="logo" :src="(login_mess.gsiId==15&&this.login_mess.identity!=3&&this.login_mess.identity!=6)?basic_static + 'learnspace/images/home/lx-logo.png':basic_static + 'learnspace/images/home/logo1.png'" />
				<!-- 菜单容器 - 新增wrapper控制溢出 -->
				<div class="menu-wrapper" ref="menuWrapper" @scroll="checkMenuOverflow">
					<ul class="flex_start menu-ul" ref="menuUl">
						<li class="flex_center text_16" v-for="item in visibleMenuList" :key="item.id" @click="changeMenu(item)"
							:class="menu_id == item.id ? 'active' : ''">
							{{ item.title }}
						</li>
					</ul>
				</div>
				
				<!-- 切换箭头容器 - 仅在溢出时显示 -->
				<div class="change_menu flex_center" v-if="showArrowContainer">
					<i class="el-icon-arrow-left" @click="scrollMenu(-1)" :class="{active: canScrollLeft}"></i>
					<i class="el-icon-arrow-right" @click="scrollMenu(1)" :class="{active: canScrollRight}"></i>
				</div>
			</div>
			<div v-if="token&&login_mess.userName&&$route.name!='bkcode'&&$route.name!='bkexplain'" class="flex_start">
				<p @click="dialogVisible = true" :class="login_mess.identity ==3? 'area_role':(login_mess.identity ==2||login_mess.identity == 5||login_mess.identity ==6||login_mess.identity ==4)? 'school_role': login_mess.identity == 1? 'teacher_role': 'student_role'">
				<img :src="login_mess.identity ==3? require('../assets/area.png'):(login_mess.identity ==2||login_mess.identity == 5||login_mess.identity ==6||login_mess.identity ==4)? require('../assets/school.png'): login_mess.identity == 1? require('../assets/teacher.png'): require('../assets/student.png')">
				{{
						login_mess.identity == 5 ? '年级主任' : login_mess.identity == 4 ? '学科研训员' :
						login_mess.identity ==3
				? "区管理员"
				: login_mess.identity ==2
				? "校管理员"
				: login_mess.identity == 1
				? "教师"
				: login_mess.identity == 4
				? "学科研训员"
				: login_mess.identity == 6
				? "集团校管理员"
				: "学生"
				}}</p>
				<el-popover v-if="login_mess.identity !=0" placement="bottom" width="400" :disabled="notice_list.length==0" trigger="click">
					<ul class="notice_ul">
						<li class="flex_start" v-for="(item,index) in notice_list" @click="readList(item,index)">
							<img  src="https://cdn.tqxxkj.cn/static/learnspace/images/notice-list.png"  alt="logo" />
							<div>
								<p class="text_14 grey1">{{item.content}}</p>
								<p class="text_12 grey3">{{item.createTime}}</p>
							</div>
						</li>
					</ul>
  					<img slot="reference" :src="notice_list.length>0?'https://cdn.tqxxkj.cn/static/learnspace/images/notice1.png':'https://cdn.tqxxkj.cn/static/learnspace/images/notice-no1.png'" class="notice" alt="logo" />
				</el-popover>
				<el-dropdown >
					<div class="el-dropdown-link flex_start head">
						<img src="https://cdn.tqxxkj.cn/static/learnspace/images/home/default-head1.png" alt="logo" />
						<p class="text_14_bold">{{ login_mess.userName }}</p>
						<i class="el-icon-caret-bottom el-icon--right" style="color: #fff" ></i>
					</div>
					<el-dropdown-menu slot="dropdown" >
						<el-dropdown-item @click.native="dialogVisible = true">切换身份</el-dropdown-item>
						<el-dropdown-item @click.native="$router.push('/set/tsmaintain')"
							v-if="login_mess.identity == 3||login_mess.identity == 4">特色课程维护</el-dropdown-item>
							<el-dropdown-item @click.native="$router.push('/set/jtx')"
							v-if="login_mess.identity == 3||login_mess.identity == 6">集团校维护</el-dropdown-item>
							<el-dropdown-item @click.native="$router.push('/set/xdgl')"
							v-if="login_mess.identity == 3">学段维护</el-dropdown-item>
							<el-dropdown-item @click.native="$router.push('/set/mlgl')"
							v-if="login_mess.identity == 3">目录维护</el-dropdown-item>
						<el-dropdown-item @click.native="$router.push('/set/admin')"
							v-if="login_mess.identity == 3||login_mess.identity == 4||login_mess.identity == 2">权限设置</el-dropdown-item>
						<el-dropdown-item @click.native="$router.push('/set/group')" v-if="login_mess.identity!=0">备课组管理</el-dropdown-item>
							<el-dropdown-item @click.native="dialogVisibleSfbd=true" v-if="login_mess.identity != 0" >身份绑定</el-dropdown-item>
						<el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="no-login flex_center" @click="toLogin" v-if="!token||!login_mess.userName">
				<img class="head-img" :src="basic_static + 'learnspace/images/home/head.png?v=1'" />
				<p class="text_14_bold">登录</p>
			</div>
			<div class="el-dropdown-link flex_start head" v-if="token&&($route.name=='bkcode'||$route.name=='bkexplain')">
				<img src="https://cdn.tqxxkj.cn/static/learnspace/images/home/default-head.png" alt="logo" />
				<p class="text_14_bold">{{ login_mess.userName }}</p>
			</div>
			<el-dialog :close-on-click-modal="false" :visible.sync="$store.state.user.login_dialog" class="login-dialog" width="456px" v-if="$store.state.user.login_dialog" @before-close="beforeClose" 
				:modal-append-to-body="false">
				<Login  @setPsw="setPsw" @close="close"></Login>
			</el-dialog>
			<el-dialog title="切换身份" v-if="dialogVisible" :visible.sync="dialogVisible" width="456px" :modal-append-to-body="false" class="zdy-dialog" >
				<Role @close="close"></Role>
			</el-dialog>
			<el-dialog :visible.sync="dialogVisibleForget" width="456px" v-if="dialogVisibleForget" class="login-dialog" 
				:modal-append-to-body="false">
				<Forget @close="close"></Forget>
			</el-dialog>
			<el-dialog title="身份绑定" :visible.sync="dialogVisibleSfbd" width="456px" v-if="dialogVisibleSfbd" :modal-append-to-body="false" class="zdy-dialog" >
				<RoleBind @close="close"></RoleBind>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import { getJtx2026LoginTicket, getRgzntsLoginTicket } from "../api/rgznts";
	import Role from "./Role.vue";
	import Login from "./Login.vue";
	import Forget from "./Forget.vue";
	import RoleBind from './RoleBind.vue'
	import { clearCookie, getCookie, noToken, getDeviceFingerprint, getQueryVariable } from "../util/index";
	import { mapGetters } from "vuex";
	import { getInfoDetail, userLogout,websiteMessage,websiteMessageRead, zntLogin, showIdentity } from "../api/login";
	import { setCookie } from "../util/index";
	export default {
		components: { Role, Login, Forget,RoleBind },
		data() {
			return {
				activeIndex: "1",
				dialogVisible: false,
				token: null,
				tab_id: "",
				dialogVisibleForget: false,
				dialogVisibleLogin:false,
				dialogVisibleSfbd:false,
				menu_id: '1',
				notice_list:[],
				showArrowContainer: false, // 是否显示箭头容器
				canScrollLeft: false,      // 能否向左滚动（左箭头高亮）
				canScrollRight: false,     // 能否向右滚动（右箭头高亮）
				scrollStep: 200,           // 每次滚动距离
			};
		},
		mounted() {
			window.addEventListener('resize', this.checkMenuOverflow);
			this.$nextTick(() => {
				this.checkMenuOverflow();
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkMenuOverflow);
		},
		watch: {
			$route: {
				handler: function () {
					this.setActiveMenuByRoute();
				},
				deep: true,
			},
			login_mess: {
				handler: function () {
					this.handleLoginInfoChange();
				},
				deep: true,
			},
		},
		async created() {
			this.token = getCookie("access-token");
			if (this.token) {
				await this.getInfoDetail();
			}else{
				this.$store.commit('set_login_mess',{})
			}
			this.setActiveMenuByRoute();
			this.$store.commit('set_login_dialog',false)
		},
		methods: {
			setActiveMenuByRoute() {
				const path = this.$route.path || "";
				if (path == "/application/front/ai") {
					this.menu_id = 10;
				} else if (path.indexOf("application") > -1) {
					this.menu_id = 5;
				} else if (path.indexOf("space") > -1) {
					this.menu_id = 2;
				} else if (path.indexOf("community") > -1) {
					this.menu_id = 16;
				} else if (path.indexOf("resource") > -1) {
					this.menu_id = 3;
				} else if (path.indexOf("screen") > -1) {
					this.menu_id = 9;
				} else if (path.indexOf("glzp") > -1) {
					this.menu_id = 14;
				} else {
					this.menu_id = 1;
				}
			},
			handleLoginInfoChange() {
				this.$store.commit('set_menu_list', this.buildMenuList())
				if(!this.login_mess.identity&&this.login_mess.identity!=0){
					this.token=null
				}else{
					this.token = getCookie("access-token");
					this.websiteMessage()
				}
				console.log(getQueryVariable('is_judge_role_show'),'getQueryVariable()')
				if(localStorage.getItem("is_judge_role_show")){
					this.getShowIdentity()
				}
				this.scheduleCheckMenuOverflow()
			},
			buildMenuList() {
				const identity = this.login_mess.identity

				if(identity == 1 || identity == 2){
					const menuList = this.getCommonMenuList(true)
					this.appendCockpitMenu(menuList)
					this.appendRgzntsMenu(menuList)
					this.appendSubscriptionMenu(menuList)
					this.appendGroupMenu(menuList, this.login_mess.isGroupMember)
					this.appendExpertMenu(menuList)
					this.appendDoubleLineMenu(menuList)
					this.appendDataManageMenu(menuList)
					return menuList
				}

				if(identity == 3){
					const menuList = this.getCommonMenuList(true)
					this.appendRgzntsMenu(menuList)
					this.appendSubscriptionMenu(menuList)
					this.appendGroupMenu(menuList, true)
					this.appendExpertMenu(menuList)
					this.appendDoubleLineMenu(menuList)
					this.appendDataManageMenu(menuList)
					return menuList
				}

				if(identity == 4 || identity == 0 || identity == 5){
					const menuList = this.getCommonMenuList(false)
					this.appendRgzntsMenu(menuList)
					this.appendSubscriptionMenu(menuList)
					this.appendExpertMenu(menuList)
					return menuList
				}

				if(identity == 6){
					const menuList = this.getCommonMenuList(false)
					this.appendRgzntsMenu(menuList)
					this.appendSubscriptionMenu(menuList)
					this.appendGroupMenu(menuList, true)
					this.appendExpertMenu(menuList)
					return menuList
				}

				const menuList = this.getCommonMenuList(true)
				this.appendRgzntsMenu(menuList)
				this.appendDataManageMenu(menuList)
				return menuList
			},
			getCommonMenuList(includeOa) {
				const menuList = [
					this.createCurrentMenu(1, "首页", "/homepage/index"),
					this.createCurrentMenu(2, "数字化教学", "/space/my"),
					this.createCurrentMenu(3, "资源中心", "/resource/index"),
					this.createCurrentMenu(16, "社区教育", "/community/index"),
				]
				if(includeOa){
					menuList.push(this.createCurrentMenu(5, "OA应用中心", "/application"))
				}
				menuList.push(this.createCurrentMenu(10, "鼓e·AI共创空间", "/application/front/ai"))
				menuList.push(this.createCurrentMenu(14, "首善智评", "/glzpPortal"))
				return menuList
			},
			createCurrentMenu(id, title, url) {
				return { id, title, url, show: true, type: 'current' }
			},
			appendRgzntsMenu(menuList) {
				menuList.push({ id: 15, title: "人工智能通识教育", url: "https://rgznts.glzhxx.com/#/pc/home", show: true, type: 'open' })
			},
			appendSubscriptionMenu(menuList) {
				if(!this.login_mess.canGljfzd) return
				menuList.push({
					id: 11,
					title: "教辅征订管理平台",
					url: `https://apps.tq-edu.com/gljfzdglpt/#/land?cropId=${this.login_mess.corpId}&wxUserId=${this.login_mess.wxUserId}&phone=${this.login_mess.mobile}&role=${this.login_mess.identity}&stage=${this.login_mess.stageIds}&schoolName=${this.login_mess.gsiName}`,
					show: true,
					type: 'open',
				})
			},
			appendGroupMenu(menuList, showMenu) {
				if(!showMenu) return
				menuList.push({ id: 8, title: "小学教育集团数智平台", url: "https://jtxkh.glzhxx.com/#/login", show: true, type: 'open' })
			},
			appendExpertMenu(menuList) {
				if(this.login_mess.gsiName != '鼓楼e学校') return
				menuList.push({
					id: 13,
					title: "鼓楼专家管理系统",
					url: `https://apps.tq-edu.com/glzjglxt/#/login?wxUserId=${this.login_mess.wxUserId}&mobile=${this.login_mess.mobile}`,
					show: true,
					type: 'open',
				})
			},
			appendDoubleLineMenu(menuList) {
				menuList.push({ id: 6, title: "双线课堂", show: true })
			},
			appendCockpitMenu(menuList) {
				if(this.login_mess.gsiId != 1 && this.login_mess.gsiId != 15) return
				menuList.push({
					id: 9,
					title: "数据驾驶舱",
					url: this.login_mess.gsiId == 1 ? "/screen/index" : "/screen/home",
					show: true,
					type: 'current',
				})
			},
			appendDataManageMenu(menuList) {
				menuList.push({
					id: 7,
					title: "数据管理",
					url: `https://dc.glzhxx.com/#/landpage?corpId=${this.login_mess.corpId}&identity=${this.login_mess.identity}`,
					show: true,
					type: 'open',
				})
			},
			scheduleCheckMenuOverflow(delay = 200) {
				this.$nextTick(() => {
					setTimeout(() => {
						this.checkMenuOverflow();
					}, delay);
				});
			},
			scrollMenu(direction) {
				const wrapper = this.$refs.menuWrapper;
				if (!wrapper) return;
				
				const newScrollLeft = wrapper.scrollLeft + (direction * this.scrollStep);
				wrapper.scrollTo({
					left: newScrollLeft,
					behavior: 'smooth'
				});
				
				setTimeout(() => this.checkMenuOverflow(), 300);
			},
			
			checkMenuOverflow() {
				const wrapper = this.$refs.menuWrapper;
				const menuUl = this.$refs.menuUl;
				
				if (!wrapper || !menuUl) return;
				
				// 1. 判断菜单是否溢出容器
				const isOverflow = menuUl.offsetWidth > wrapper.offsetWidth;
				this.showArrowContainer = isOverflow;
				
				if (!isOverflow) {
					this.canScrollLeft = false;
					this.canScrollRight = false;
					return;
				}
				
				// 2. 判断滚动方向状态（控制箭头高亮）
				// 左箭头：滚动位置 > 0 时可滚动（高亮）
				this.canScrollLeft = wrapper.scrollLeft > 10;
				// 右箭头：未滚动到最右侧时可滚动（高亮）
				const maxScrollLeft = menuUl.offsetWidth - wrapper.offsetWidth;
				this.canScrollRight = wrapper.scrollLeft < (maxScrollLeft - 10);
			},
			
			
			async getShowIdentity(){
				let params = {
					mobile:this.login_mess.mobile,
					deviceId:await getDeviceFingerprint()
				}
				console.log(params,'sss')
				let res = await showIdentity(params)
				if(res){
					if(res.data){
						console.log('展示')
						this.dialogVisible = true
					}else{
						console.log('不展示')
						localStorage.removeItem("is_judge_role_show")
						// localStorage.setItem("is_judge_role_show", false)
					}
				}
			},
			async readList(item,index){
				let data={
					websiteMessageId:item.websiteMessageId
				}
				await websiteMessageRead(data)
				this.notice_list.splice(index,1)
				// 0:资源；1:备课；2:应用；3：个人空间
				if(item.module==1){
					if(item.roleType=='apply'){
						this.$router.push('/resource/detail/'+item.dataId)
					}else{
						this.$router.push(`/space/audit/detail/${item.verifyDataId}/resource`)
					}

				}else if(item.module==0){
					if(item.roleType=='apply'){
						this.$router.push('/resource/detail/'+item.dataId)
					}else{
						this.$router.push(`/space/audit/detail/${item.verifyDataId}/resource`)
					}

				}else if(item.module==2){
					if(item.roleType=='apply'){
						this.$router.push('/application/admin/apply')
					}else{
						this.$router.push('/application/admin/audit')
					}

				}
				else if(item.module==3){
					if(item.roleType=='apply'){
						this.$router.push('/space/bk/myspacedetail/'+item.dataId)
					}else{
						this.$router.push(`/space/audit/detail/${item.verifyDataId}/bk`)
					}

				}
			},
			async websiteMessage(){
				let res=await websiteMessage()
				if(res){
					this.notice_list=res.data
				}
			},
			beforeClose(){
				this.$store.commit('set_login_dialog',false)
			},
			toLogin(){
				this.$store.commit('set_login_dialog',true)
			},
			async getInfoDetail() {
				let res = await getInfoDetail();
				if (res) {
					localStorage.setItem("userInfo", JSON.stringify(res.data));
					this.$store.commit("set_login_mess", res.data);
					setCookie("userId", res.data.userId + "");
					// res.data.identitys.forEach((item) => {
					//     if (item.isCurrent == 1) {
					//         // this.login_mess=item
					//         this.$store.commit("set_login_mess", item);
					//     }
					// });
				}
			},
		   /**
     * uri 打开客户端的uri
     * failCb 打开客户端失败回调
     * successCb 打开客户端成功回调
     */
	  openUriWithInputTimeoutHack(uri, failCb, successCb) {
	    let target = document.createElement('input')
	    target.style.width = '0'
	    target.style.height = '0'
    	    target.style.position = 'fixed'
	    target.style.top = '0'
	    target.style.left = '0'
	    document.body.appendChild(target)
	    target.focus();
	    var handler = this._registerEvent(target, "blur", onBlur);
	    console.log('focus')
	    function onBlur() {
		    console.log('blur')
		    successCb && successCb()
		    handler.remove()
		    clearTimeout(timeout)
		    document.body.removeChild(target)
	    };
	    location.href = uri
	    var timeout = setTimeout(function () {
		    failCb && failCb()
		    handler.remove()
		    document.body.removeChild(target)
	    }, 1000);
    },
 
     _registerEvent(target, eventType, cb) {
        if (target.addEventListener) {
            target.addEventListener(eventType, cb);
            return {
                remove: function () {
                    target.removeEventListener(eventType, cb);
                }
            };
        } else {
            target.attachEvent(eventType, cb);
            return {
                remove: function () {
                    target.detachEvent(eventType, cb);
                }
            };
        }
    },
    

			async changeMenu(item) {
				if (this.menu_id == 1 && item.id == 1 && this.$route.path == '/homepage/index') return;
				if (item.id == 1) {
					this.$router.push(item.url)
					return;
				}
				if (item.id == 16) {
					this.$router.push(item.url)
					return;
				}

				if (item.id == 15 && !getCookie('access-token')) {
					window.open(item.url)
					return
				}
				if (!noToken()) return

				if (item.id == 6) {
					this.openDoubleLineClassroom()
					return;
				}
				if (this.isExternalMenu(item)) {
					await this.openExternalMenu(item)
					return
				}
				if(item.id == 10){
					await this.openAiSpace()
					return
				}

				this.menu_id = item.id;
				if (item.url) {
					this.$router.push(item.url)
				}
				this.scheduleCheckMenuOverflow(0)
			},
			isExternalMenu(item) {
				return [4, 7, 8, 11, 13, 15].indexOf(item.id) > -1
			},
			async openExternalMenu(item) {
				if (item.id == 15) {
					await this.openRgzntsMenu(item)
					return
				}
				if (item.id == 8) {
					await this.openGroupPlatform(item)
					return
				}
				window.open(item.url)
			},
			async openRgzntsMenu(item) {
				const res = await getRgzntsLoginTicket()
				const ticket = res && res.data && res.data.ticket
				if (ticket) {
					window.open(`${item.url}?ticket=${ticket}`)
					return
				}
				alert("获取人工智能通识登录票据失败")
			},
			async openGroupPlatform(item) {
				const res = await getJtx2026LoginTicket()
				const ticket = res && res.data && res.data.ticket
				if (ticket) {
					window.open(`${item.url}?ticket=${encodeURIComponent(ticket)}`)
					return
				}
				alert("获取小学教育集团数智平台登录票据失败")
			},
			openDoubleLineClassroom() {
				let protocalUrl = `mskzkt-edu-teacher://`
				this.openUriWithInputTimeoutHack(protocalUrl, () => {
					alert('未安装双线课堂')
				})
			},
			async openAiSpace() {
				console.log('AI智能体')
				let res = await zntLogin()
				if(res){
					window.open(res.data)
				}
			},
			setPsw() {
				this.dialogVisibleForget = true;
				this.$store.commit('set_login_dialog',false)
			},
			async loginOut() {
				await userLogout();
                if(this.$route.path=='/homepage/index'){
                    // location.reload();
                }else{
					this.$router.replace('/homepage/index')
                }
				clearCookie();
				localStorage.clear()
				this.$store.commit('set_login_mess',{})
			},
			close(type) {
				this.dialogVisible = false;
				this.dialogVisibleForget=false
				this.dialogVisibleSfbd=false
				if(type){
					this.getInfoDetail()
				}
			},
		},
		computed: {
			...mapGetters(["login_mess", "basic_static",'login_dialog','menu_list']),
			visibleMenuList() {
				return (this.menu_list || []).filter(item => item.show !== false)
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "../style/element.scss";
	.change_menu{
		width: 60px;
height: 32px;
border-radius: 16px;
border: 1px solid #FFFFFF;
cursor: pointer;
margin: 0 14px;
color: #92A4FF;
// .active{color: #fff;}
	}
	/* 菜单容器样式 */
	.menu-wrapper {
		overflow: hidden;       /* 隐藏溢出内容 */
		white-space: nowrap;    /* 防止菜单换行 */
		flex: 1;          /* 占满剩余空间 */
		height: 100%;
		position: relative;
	}
	
	/* 菜单列表样式 */
	.menu-ul {
		height: 100%;
		padding: 0;
		margin: 0;
		display: inline-flex;   /* 确保菜单在一行显示 */
	}
	/* 箭头高亮状态 */
	.change_menu i.active {
		color: #fff;         /* 高亮颜色 */
		// transform: scale(1.1);  /* 轻微放大效果 */
	}
	
	/* 箭头不可用状态 */
	.change_menu i:not(.active) {
		opacity: 0.5;
		cursor: not-allowed;
	}
	
		
	// .change_menu i {
	// 	width: 30px;
	// 	height: 30px;
	// 	line-height: 30px;
	// 	text-align: center;
	// 	cursor: pointer;
	// 	color: #999;
	// 	transition: all 0.2s;
	// }
	
	// .change_menu i.active {
	// 	color: #409eff; /* 箭头激活状态颜色 */
	// }
	
	// .change_menu i:not(.active) {
	// 	opacity: 0.5;
	// 	cursor: not-allowed;
	// }

	.teacher_role{
		background: #FFF6EB;
border-radius: 12px;
font-size: 14px;
color: #FFA532;
padding: 6px 12px;
white-space: nowrap;
margin-right: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
img{width:14px;margin-right: 4px;}
	}
	.student_role{
		background: #E9FBF3;
border-radius: 12px;
font-size: 14px;
color: #23D486;
padding: 6px 12px;
white-space: nowrap;
margin-right: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
img{width:14px;margin-right: 4px;}
	}
	.area_role{
		background: #E9ECFF;
border-radius: 12px;
font-size: 14px;
color: #4260FD;
padding: 6px 12px;
white-space: nowrap;
margin-right: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
img{width:14px;margin-right: 4px;}
	}
	.school_role{
		background: #F1EBFF;
border-radius: 12px;
font-size: 14px;
color: #7C3BFF;
padding: 6px 12px;
white-space: nowrap;
margin-right: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
img{width:14px;margin-right: 4px;}
	}
	.notice{width: 18px;height: 20px;margin-right: 16px;cursor: pointer;}
	.notice_ul{
		padding: 8px;
		max-height: 400px;
    	overflow-y: auto;
		li{
			margin-bottom: 16px;
			cursor: pointer;
			img{
				width: 28px;
				margin-right: 8px;
			}
		}
		li:last-child{margin-bottom: 0;}
	}
	/*引入公共样式*/
	.top {
		background: $--color-primary;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 100;
	}
	.grey{
		background: #F5F7FB ;
	}

	.head {
		padding: 0 16px 0 7px;
		height: 48px;
		border-radius: 24px;
		border: 1px solid $line;

		p {
			color: $white;
			white-space: nowrap;
			margin-right: 3px;
		}

		img {
			width: 32px;
			height: 32px;
			margin-right: 8px;
		}
	}

	.header {
		height: 64px;
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		padding: 0 40px;
		.logo {
			width: auto;
			height:40px;
			margin-right: 30px;
		}

		.menu-ul {
			height: 100%;
			color: $white;
			// overflow-x: auto;
			// margin-right: 24px;
			// max-width: calc(100vw - 400px);
			li {
				cursor: pointer;
				border-radius: 8px 8px 0px 0px;
				background: $--color-primary;
				height: 100%;
				padding: 0 10px;
				white-space: nowrap;
			}

			li:hover {
				font-weight: bold;
				color: $white;
			}

			li.active {
				background: $white;
				font-weight: bold;
				color: $--color-primary;
			}
		}

		.no-login {
			width: 92px;
			height: 48px;
			background: $white;
			border-radius: 24px;
			border: 1px solid $line;
			color: $grey4;
			cursor: pointer;
			white-space: nowrap;
			.head-img {
				width: 34px;
				height: 34px;
				margin-right: 7px;
			}
		}
	}
</style>
